export const ChevronDown = ({
  color = "",
  size = 24,
  className,
}: {
  color?: string;
  size?: string | number;
  className?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "var(--text-body, #475569)"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...{ className }}
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
};
